<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="订单号/买家/收货姓名/收货电话" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-select v-model="type" slot="prepend" placeholder="筛选条件">
                      <el-option label="买家会员名" value="4"></el-option>
                      <el-option label="订单号"   value="1"></el-option>
                      <el-option label="收货姓名" value="2"></el-option>
                      <el-option label="收货电话" value="3"></el-option> 
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="下单时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        prop="ordernum"
        label="订单号"
        >
      </el-table-column>
      <el-table-column
        label="买家">
        <template slot-scope="scope"> 
          <span>{{scope.row.buyername}}<Userinfo :userid='scope.row.userid'/></span> 
        </template>
      </el-table-column>
      <el-table-column
        label="订货商品">
        <template slot-scope="scope"> 
             <div v-for='item in scope.row.ordergoods' :key='item.id'>
               <div>{{item.name}}</div>
               <div><el-badge :value="item.nums" class="item"></el-badge>x{{item.price}}</div> 
             </div>  
             <div v-if="scope.row.ordertype==6" class="smallwords">含1372优惠券一张</div>  
        </template>
      </el-table-column>
      <el-table-column
        label="卖家">
        <template slot-scope="scope"> 
          <span>{{scope.row.sellername}}<Userinfo :userid='scope.row.sellerid'/></span> 
        </template>
      </el-table-column>
      <el-table-column
        label="实付款">
        <template slot-scope="scope"> 
          <span>{{scope.row.totalmoney}}</span> 
          <div v-if="scope.row.discount>0 && scope.row.ordertype==3"><el-tag type="danger" size="mini">含补货优惠:{{scope.row.discount}}</el-tag></div>
          <div v-if="scope.row.coupontotal>0" class="smallwords">优惠券抵扣-{{scope.row.coupontotal}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope"> 
          <div><el-tag :type="scope.row.status | toStatusStyle">{{scope.row.status | toStatusWord}}</el-tag> </div>
          <div v-if="scope.row.status!=5"><el-tag type="warning" v-if="scope.row.iswait==1">补货等待中</el-tag><el-tag type="warning" v-else-if="scope.row.iswait==3">升级等待中</el-tag></div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
              <!--<el-dropdown split-button type="primary" @click='handleLook(scope.row)' @command='(command)=>handleItem(command,scope.row.id)' trigger="click">
              查看
              <el-dropdown-menu slot="dropdown">
               <el-dropdown-item command='hand'>线下确认</el-dropdown-item>
                <el-dropdown-item command='relive'>订单复活</el-dropdown-item>
                <el-dropdown-item command='cancel'>取消订单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>-->
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
      <el-dialog title="订单详情" :visible.sync="dialogFormVisible" custom-class="commonDiag">
         <el-card class="box-card">
          <div slot="header">
            <span>基本信息</span>
          </div>
          <div>
            <ul class='order-detail'>
               <li>订单号：{{orderDetail.ordernum}}</li>
               <li>订货商品：
                  <div v-for='item in orderDetail.ordergoods' :key='item.id'>
                      {{item.name}}x<el-badge :value="item.nums" class="item"></el-badge>
                  </div> 
               </li>
               <li>订单总额：{{orderDetail.totalmoney}}</li>
               <li>订单优惠：-{{orderDetail.discount}}</li>
               <li>订单实付：{{orderDetail.realmoney}}</li>
               <li>支付方式：{{orderDetail.paytype |toPaytype}}</li>
               <li>订单状态：{{orderDetail.status | toStatusWord}}</li>
            </ul>  
          </div>
        </el-card>
        <el-card class="box-card" v-if="hasprize">
          <div slot="header">
            <span>奖励信息</span>
          </div>
          <div>
              <el-table
                :data="orderDetail.prizelist"
                style="width: 100%">
                <el-table-column
                  prop="prizer"
                  label="奖励人"
                 >
                </el-table-column>
                <el-table-column
                  prop="typename"
                  label="积分类型"
                 >
                </el-table-column>
                <el-table-column
                  prop="points"
                  label="积分值">
                </el-table-column>
              </el-table>
          </div>
        </el-card>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="您确定要线下确认这笔订单吗？" :visible.sync="yzmDialogFormVisible" custom-class="commonDiag">
        <el-input placeholder="请输入收到的验证码" v-model="yzm">
          <template slot="prepend"><span @click="sendSms(22)">发送验证码</span></template>
        </el-input>
       <div slot="footer" class="dialog-footer">
         <el-button @click="yzmDialogFormVisible = false">取 消</el-button>
         <el-button type="primary" @click="doOfflineSet">确 定</el-button>
       </div>
     </el-dialog>

     <el-dialog title="您确定要取消这笔订单吗（如果是线上付款，请联系财务退款）？" :visible.sync="cancelDialogFormVisible" custom-class="commonDiag">
        <el-input placeholder="请输入收到的验证码" v-model="yzm_cancel">
          <template slot="prepend"><span @click="sendSms(99)">发送验证码</span></template>
        </el-input>
     <div slot="footer" class="dialog-footer">
       <el-button @click="cancelDialogFormVisible = false">取 消</el-button>
       <el-button type="primary" @click="doCancelOrder">确 定</el-button>
     </div>
   </el-dialog>

   </div> 
</template>

<script>
import Userinfo from '@/components/userinfo'  
export default {
  data(){
     return {
        tableData:[],
        startDate:'',
        endDate:'',
        type:'',
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        },
        orderDetail:{},
        hasprize:0,
        dialogFormVisible:false,

        yzm:'',
        yzmDialogFormVisible:false,
        orderid:'',

        yzm_cancel:'',
        cancelDialogFormVisible:false,
        
        processing:false
     }
  },
  components:{
    Userinfo
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/order/getOrderList",{pageinfo:this.pageinfo,startdate:this.startDate,enddate:this.endDate,keywords:this.keywords,type:this.type}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.orderlist
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleLook(orderItem){
         this.$post("/order/getOrderDetail",{orderid:orderItem.id}).then((data)=>{
               if(data.result.success){
                  this.orderDetail=data.result.info
                  this.hasprize=this.orderDetail.hasprize
                  this.dialogFormVisible=true
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      sendSms(type){
        this.$post("/sms/getSmscode",{type:type}).then((data)=>{
               if(data.result.success){
                  this.$message.success(data.result.info)
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleItem(command,orderid){
        switch(command){
          case 'hand': 
                this.yzm=''
                this.orderid=orderid
                this.yzmDialogFormVisible=true
                break;
          case 'relive':
                this.$post("/order/reliveOrder",{orderid:orderid}).then((data)=>{
                   if(data.result.success){
                      this.$message.success(data.result.info)
                      this.getList()
                   }else{
                      this.$message.error(data.result.info)
                   }
                })
                break;   
          case 'cancel':
                this.yzm_cancel=''
                this.orderid=orderid
                this.cancelDialogFormVisible=true
                break;         
          default:
                this.$message.error("选项有误");      
        }
      },
      doOfflineSet(){
           if(this.processing){
            this.$message.error("请等待提交完成");return  false;   
           }
           if(this.yzm==''){
            this.$message.error("请输入验证码");return false;   
           }
           if(this.orderid==''){
            this.$message.error("内部参数有误");return false;   
           }
           this.processing=true
           this.$post("/order/offlineOrderset",{orderid:this.orderid,yzm:this.yzm}).then((data)=>{
                  this.processing=false
                  if(data.result.success){
                      this.yzmDialogFormVisible=false
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
           })  
      },
      doCancelOrder(){
          if(this.processing){
            this.$message.error("请等待提交完成");return  false;   
           }
           if(this.yzm_cancel==''){
            this.$message.error("请输入验证码");return false;   
           }
           if(this.orderid==''){
            this.$message.error("内部参数有误");return false;   
           }
           this.processing=true
           this.$post("/order/doCancelOrder",{orderid:this.orderid,yzm:this.yzm_cancel}).then((data)=>{
                  this.processing=false
                  if(data.result.success){
                      this.cancelDialogFormVisible=false
                      this.$message({message:data.result.info,type:'success'})
                      setTimeout(()=>{this.getList()},300)
                  }else{
                      this.$message.error(data.result.info)
                  } 
           })  
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
.smallwords{font-size:12px;color:#999;}
</style>
